"use strict";
var Observable_1 = require('../../Observable');
var reduce_1 = require('../../operator/reduce');
Observable_1.Observable.prototype.reduce = reduce_1.reduce;
//# sourceMappingURL=reduce.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@nordpoolgroup/nps-angular-2-common/~/rxjs/add/operator/reduce.js
// module id = 1011
// module chunks = 0